import React from "react";
import Button from "../../components/button/Button";

const RoleDeleteConfirmModal = ({
  show,
  onClose,
  onConfirm,
  isLoading,
  roleId,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.4)" }}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 520 }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Delete Role</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            <h3 className="mb-1">Are you sure you want to delete this role?</h3>
            <div className="text-muted mb-2">
              
            </div>
            <div className="text-danger">This action cannot be undone.</div>
          </div>

          <div className="modal-footer d-flex justify-space-between gap-2">
            <Button
              className="btn btn-secondary w-40"
              disabled={isLoading}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-danger w-40"
              disabled={isLoading}
              onClick={onConfirm}
            >
              {isLoading ? "Deleting..." : "Yes, Delete"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleDeleteConfirmModal;
